module.exports = __webpack_public_path__ + "static/media/53.af5dd2d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/53.png
// module id = 626
// module chunks = 0